import {mainQuery} from '@github-ui/react-core/future/main-query'
import {reposCommitActivityAppBuilder} from '../config/app-builder'

export type CommitActivityResponse = {}

export const commitActivityRoute = reposCommitActivityAppBuilder.createQueryRouteConfig('commitActivityRoute', {
  path: '/:owner/:repo/graphs/commit-activity',
  queries: [mainQuery<CommitActivityResponse>()],
})
